export default __webpack_public_path__ + "static/media/queue_bin.d7a9b910.svg";